import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { Card } from 'reactstrap';
import Table from '../../../common/Table';
import { bankReconciliationBankSummaryColumns } from '../../../../config/columns';
import {
  getBankReconciliationBankSummary,
  clearBankReconciliationBankSummary,
} from '../../../../actions';

const MIN_ROWS = 6;

const BankReconciliationBankSummaryTable = ({
  filters,
  bankList,
  bankTotal,
  loading,
  dispatchGetBankReconciliationBankSummary,
  dispatchClearBankReconciliationBankSummary,
}) => {
  useEffect(() => () => dispatchClearBankReconciliationBankSummary(), []);

  useEffect(() => {
    const { from, to, bankId, agencyId } = filters;

    dispatchGetBankReconciliationBankSummary({ from, to, bankId, agencyId });
  }, [filters]);

  const data = bankList.toJS();

  return (
    <Card className="shadow-sm border-0 mb-4">
      <div className="px-3 py-2 border-bottom bg-white">
        <span className="font-weight-medium">
          Resumen por banco: registrado en FLIT vs. confirmado por el banco
        </span>
      </div>
      <Table
        columns={bankReconciliationBankSummaryColumns(bankTotal)}
        data={data}
        loading={loading}
        manual={false}
        showPagination={false}
        pageSize={Math.max(data.length, MIN_ROWS)}
      />
    </Card>
  );
};

const bankTotalShape = PropTypes.shape({
  depositCount: PropTypes.number,
  registeredAmount: PropTypes.number,
  confirmedAmount: PropTypes.number,
  unmatchedCount: PropTypes.number,
  unmatchedAmount: PropTypes.number,
  partialMatchCount: PropTypes.number,
  amountDifference: PropTypes.number,
});

BankReconciliationBankSummaryTable.propTypes = {
  filters: PropTypes.shape({
    from: PropTypes.string,
    to: PropTypes.string,
    bankId: PropTypes.number,
    agencyId: PropTypes.number,
  }).isRequired,
  bankList: PropTypes.instanceOf(Immutable.List).isRequired,
  bankTotal: bankTotalShape,
  loading: PropTypes.bool,
  dispatchGetBankReconciliationBankSummary: PropTypes.func.isRequired,
  dispatchClearBankReconciliationBankSummary: PropTypes.func.isRequired,
};

BankReconciliationBankSummaryTable.defaultProps = {
  bankTotal: null,
  loading: false,
};

const mapStateToProps = ({ SalesUnit }) => ({
  bankList: SalesUnit.BankReconciliation.getIn(['bankSummary', 'bankList']),
  bankTotal: SalesUnit.BankReconciliation.getIn(['bankSummary', 'bankTotal']),
  loading: SalesUnit.BankReconciliation.getIn(['bankSummary', 'loading']),
});

const mapDispatchToProps = {
  dispatchGetBankReconciliationBankSummary: getBankReconciliationBankSummary,
  dispatchClearBankReconciliationBankSummary:
    clearBankReconciliationBankSummary,
};

export { BankReconciliationBankSummaryTable };
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BankReconciliationBankSummaryTable);
